import { PageSizeSelector, renderComponent } from 'searchkit'
import { map } from 'lodash'

class PerPageSelector extends PageSizeSelector {
  render() {
    let pageSizeAccessor = this.getPageSizeAccessor()
    if(pageSizeAccessor){
      const {mod, className, label} = this.props
      let options = map(this.props.options, (option)=> {
        return {key: option, label: option + " " + label }
      })
      let selectedSize = pageSizeAccessor.getSize()
      return renderComponent(this.props.listComponent, {
        mod, className,
        disabled: !this.hasHits(),
        items: options,
        selectedItems: [selectedSize],
        toggleItem: this.setSize.bind(this),
        setItems:this.setItems.bind(this),
        urlBuilder: (item) => {},
        translate:this.translate
      })
    }
    return null
  }
}

export default PerPageSelector;



// WEBPACK FOOTER //
// ./src/PerPageSelector.js